module.exports = __webpack_public_path__ + "static/media/logo-dark.3033c01d.png";